export class ConsumerBulkInteractionModel {
    consumerIds: number[] = [];
    bulkId: string;
    scheduleTime?: Date;

}

export enum DeviceType {
    Heat,
    Electricity,
    Other
}

export class DeviceInteractionMultipleModel
{
    items: any[] = [];
    myInteractionCount: number;
    currentPage: number;
    page: number;
    inProgressCount: number;
    completedCount: number;
    totalItems: number;
    errorCount: number;
    totalPages: number;
    pageSize: number;
}
